import type { TrendingSoundsFilters } from './types';

export const SOUND_UNAVAILABLE_MESSAGE = 'Sound unavailable to play. Please try a different sound.';

export const DEFAULT_FILTERS: TrendingSoundsFilters = {
  dateRange: '7DAY',
  country: 'US',
  genre: 'ALL',
};

export const DATE_RANGE_OPTIONS = [
  { label: 'Last 1 Day', value: '1DAY' },
  { label: 'Last 7 Days', value: '7DAY' },
  { label: 'Last 30 Days', value: '30DAY' },
  { label: 'Last 90 Days', value: '90DAY' },
];

export const COUNTRY_OPTIONS = [
  { label: 'Andorra', value: 'AD' },
  { label: 'United Arab Emirates', value: 'AE' },
  { label: 'Afghanistan', value: 'AF' },
  { label: 'Antigua and Barbuda', value: 'AG' },
  { label: 'Anguilla', value: 'AI' },
  { label: 'Albania', value: 'AL' },
  { label: 'Armenia', value: 'AM' },
  { label: 'Angola', value: 'AO' },
  { label: 'Antarctica', value: 'AQ' },
  { label: 'Argentina', value: 'AR' },
  { label: 'American Samoa', value: 'AS' },
  { label: 'Austria', value: 'AT' },
  { label: 'Australia', value: 'AU' },
  { label: 'Aruba', value: 'AW' },
  { label: 'Aland', value: 'AX' },
  { label: 'Azerbaijan', value: 'AZ' },
  { label: 'Bosnia & Herzegovina', value: 'BA' },
  { label: 'Barbados', value: 'BB' },
  { label: 'Bangladesh', value: 'BD' },
  { label: 'Belgium', value: 'BE' },
  { label: 'Burkina Faso', value: 'BF' },
  { label: 'Bulgaria', value: 'BG' },
  { label: 'Bahrain', value: 'BH' },
  { label: 'Burundi', value: 'BI' },
  { label: 'Benin', value: 'BJ' },
  { label: 'Saint Barthélemy', value: 'BL' },
  { label: 'Bermuda', value: 'BM' },
  { label: 'Brunei', value: 'BN' },
  { label: 'Bolivia', value: 'BO' },
  { label: 'Caribbean Netherlands', value: 'BQ' },
  { label: 'Brazil', value: 'BR' },
  { label: 'Commonwealth of the Bahamas', value: 'BS' },
  { label: 'Bhutan', value: 'BT' },
  { label: 'Bouvet Island', value: 'BV' },
  { label: 'Botswana', value: 'BW' },
  { label: 'Belarus', value: 'BY' },
  { label: 'Belize', value: 'BZ' },
  { label: 'Canada', value: 'CA' },
  { label: 'Cocos (Keeling) Islands', value: 'CC' },
  { label: 'Democratic Republic of the Congo', value: 'CD' },
  { label: 'Central African Republic', value: 'CF' },
  { label: 'Republic of the Congo', value: 'CG' },
  { label: 'Switzerland', value: 'CH' },
  { label: "Cote D'Ivoire", value: 'CI' },
  { label: 'Cook Islands', value: 'CK' },
  { label: 'Chile', value: 'CL' },
  { label: 'Cameroon', value: 'CM' },
  { label: 'the Chinese mainland', value: 'CN' },
  { label: 'Colombia', value: 'CO' },
  { label: 'Costa Rica', value: 'CR' },
  { label: 'Cuba', value: 'CU' },
  { label: 'Cape Verde', value: 'CV' },
  { label: 'Christmas Island', value: 'CX' },
  { label: 'Cyprus', value: 'CY' },
  { label: 'Czech Republic', value: 'CZ' },
  { label: 'Germany', value: 'DE' },
  { label: 'Djibouti', value: 'DJ' },
  { label: 'Denmark', value: 'DK' },
  { label: 'Dominica', value: 'DM' },
  { label: 'Dominican Republic', value: 'DO' },
  { label: 'Algeria', value: 'DZ' },
  { label: 'Ecuador', value: 'EC' },
  { label: 'Estonia', value: 'EE' },
  { label: 'Egypt', value: 'EG' },
  { label: 'Western Sahara', value: 'EH' },
  { label: 'Eritrea', value: 'ER' },
  { label: 'Spain', value: 'ES' },
  { label: 'Ethiopia', value: 'ET' },
  { label: 'Finland', value: 'FI' },
  { label: 'Fiji', value: 'FJ' },
  { label: 'Falkland Islands', value: 'FK' },
  { label: 'Micronesia', value: 'FM' },
  { label: 'Faroe Islands', value: 'FO' },
  { label: 'France', value: 'FR' },
  { label: 'Gabon', value: 'GA' },
  { label: 'United Kingdom', value: 'GB' },
  { label: 'Grenada', value: 'GD' },
  { label: 'Georgia', value: 'GE' },
  { label: 'French Guiana', value: 'GF' },
  { label: 'Guernsey', value: 'GG' },
  { label: 'Ghana', value: 'GH' },
  { label: 'Gibraltar', value: 'GI' },
  { label: 'Greenland', value: 'GL' },
  { label: 'Gambia', value: 'GM' },
  { label: 'Guinea', value: 'GN' },
  { label: 'Guadeloupe', value: 'GP' },
  { label: 'Equatorial Guinea', value: 'GQ' },
  { label: 'Greece', value: 'GR' },
  { label: 'South Georgia and the South Sandwich Islands', value: 'GS' },
  { label: 'Guatemala', value: 'GT' },
  { label: 'Guam', value: 'GU' },
  { label: 'Guinea-Bissau', value: 'GW' },
  { label: 'Guyana', value: 'GY' },
  { label: 'Hong Kong, China', value: 'HK' },
  { label: 'Heard Island and McDonald Islands', value: 'HM' },
  { label: 'Honduras', value: 'HN' },
  { label: 'Croatia', value: 'HR' },
  { label: 'Haiti', value: 'HT' },
  { label: 'Hungary', value: 'HU' },
  { label: 'Indonesia', value: 'ID' },
  { label: 'Ireland', value: 'IE' },
  { label: 'Israel', value: 'IL' },
  { label: 'Isle of Man', value: 'IM' },
  { label: 'India', value: 'IN' },
  { label: 'British Indian Ocean Territory', value: 'IO' },
  { label: 'Iraq', value: 'IQ' },
  { label: 'Iran', value: 'IR' },
  { label: 'Iceland', value: 'IS' },
  { label: 'Italy', value: 'IT' },
  { label: 'Jersey', value: 'JE' },
  { label: 'Jamaica', value: 'JM' },
  { label: 'Jordan', value: 'JO' },
  { label: 'Japan', value: 'JP' },
  { label: 'Kenya', value: 'KE' },
  { label: 'Kyrgyzstan', value: 'KG' },
  { label: 'Cambodia', value: 'KH' },
  { label: 'Kiribati', value: 'KI' },
  { label: 'Comoros', value: 'KM' },
  { label: 'Saint Christopher and Nevis', value: 'KN' },
  { label: 'North Korea', value: 'KP' },
  { label: 'South Korea', value: 'KR' },
  { label: 'Kuwait', value: 'KW' },
  { label: 'Cayman Islands', value: 'KY' },
  { label: 'Kazakhstan', value: 'KZ' },
  { label: 'Laos', value: 'LA' },
  { label: 'Lebanon', value: 'LB' },
  { label: 'Saint Lucia', value: 'LC' },
  { label: 'Liechtenstein', value: 'LI' },
  { label: 'Sri Lanka', value: 'LK' },
  { label: 'Liberia', value: 'LR' },
  { label: 'Lesotho', value: 'LS' },
  { label: 'Lithuania', value: 'LT' },
  { label: 'Luxembourg', value: 'LU' },
  { label: 'Latvia', value: 'LV' },
  { label: 'Libya', value: 'LY' },
  { label: 'Morocco', value: 'MA' },
  { label: 'Monaco', value: 'MC' },
  { label: 'Moldova', value: 'MD' },
  { label: 'Montenegro', value: 'ME' },
  { label: 'Madagascar', value: 'MG' },
  { label: 'Marshall Islands', value: 'MH' },
  { label: 'Macedonia', value: 'MK' },
  { label: 'Mali', value: 'ML' },
  { label: 'Myanmar', value: 'MM' },
  { label: 'Mongolia', value: 'MN' },
  { label: 'Macao, China', value: 'MO' },
  { label: 'Northern Mariana Islands', value: 'MP' },
  { label: 'Martinique', value: 'MQ' },
  { label: 'Mauritania', value: 'MR' },
  { label: 'Montserrat', value: 'MS' },
  { label: 'Malta', value: 'MT' },
  { label: 'Mauritius', value: 'MU' },
  { label: 'Maldives', value: 'MV' },
  { label: 'Malawi', value: 'MW' },
  { label: 'Mexico', value: 'MX' },
  { label: 'Malaysia', value: 'MY' },
  { label: 'Mozambique', value: 'MZ' },
  { label: 'Namibia', value: 'NA' },
  { label: 'New Caledonia', value: 'NC' },
  { label: 'Niger', value: 'NE' },
  { label: 'Norfolk Island', value: 'NF' },
  { label: 'Nigeria', value: 'NG' },
  { label: 'Nicaragua', value: 'NI' },
  { label: 'Netherlands', value: 'NL' },
  { label: 'Norway', value: 'NO' },
  { label: 'Nepal', value: 'NP' },
  { label: 'Nauru', value: 'NR' },
  { label: 'Niue', value: 'NU' },
  { label: 'New Zealand', value: 'NZ' },
  { label: 'Oman', value: 'OM' },
  { label: 'Panama', value: 'PA' },
  { label: 'Peru', value: 'PE' },
  { label: 'French Polynesia', value: 'PF' },
  { label: 'Papua New Guinea', value: 'PG' },
  { label: 'Philippines', value: 'PH' },
  { label: 'Pakistan', value: 'PK' },
  { label: 'Poland', value: 'PL' },
  { label: 'Saint Pierre and Miquelon', value: 'PM' },
  { label: 'Pitcairn Islands', value: 'PN' },
  { label: 'Puerto Rico', value: 'PR' },
  { label: 'Palestine', value: 'PS' },
  { label: 'Portugal', value: 'PT' },
  { label: 'Palau', value: 'PW' },
  { label: 'Paraguay', value: 'PY' },
  { label: 'Qatar', value: 'QA' },
  { label: 'Réunion', value: 'RE' },
  { label: 'Romania', value: 'RO' },
  { label: 'Serbia', value: 'RS' },
  { label: 'Russia', value: 'RU' },
  { label: 'Rwanda', value: 'RW' },
  { label: 'Saudi Arabia', value: 'SA' },
  { label: 'Solomon Islands', value: 'SB' },
  { label: 'Seychelles', value: 'SC' },
  { label: 'Sudan', value: 'SD' },
  { label: 'Sweden', value: 'SE' },
  { label: 'Singapore', value: 'SG' },
  { label: 'Saint Helena', value: 'SH' },
  { label: 'Slovenia', value: 'SI' },
  { label: 'Svalbard and Jan Mayen', value: 'SJ' },
  { label: 'Slovakia', value: 'SK' },
  { label: 'Sierra Leone', value: 'SL' },
  { label: 'San Marino', value: 'SM' },
  { label: 'Senegal', value: 'SN' },
  { label: 'Somali', value: 'SO' },
  { label: 'Suriname', value: 'SR' },
  { label: 'South Sudan', value: 'SS' },
  { label: 'Sao Tomé and Príncipe', value: 'ST' },
  { label: 'El Salvador', value: 'SV' },
  { label: 'Syria', value: 'SY' },
  { label: 'Swaziland', value: 'SZ' },
  { label: 'Turks and Caicos Islands', value: 'TC' },
  { label: 'Chad', value: 'TD' },
  { label: 'French Southern and Antarctic Lands', value: 'TF' },
  { label: 'Togo', value: 'TG' },
  { label: 'Thailand', value: 'TH' },
  { label: 'Tajikistan', value: 'TJ' },
  { label: 'Tokelau', value: 'TK' },
  { label: 'Timor-Leste', value: 'TL' },
  { label: 'Turkmenistan', value: 'TM' },
  { label: 'Tunisia', value: 'TN' },
  { label: 'Tonga', value: 'TO' },
  { label: 'Turkey', value: 'TR' },
  { label: 'Trinidad and Tobago', value: 'TT' },
  { label: 'Tuvalu', value: 'TV' },
  { label: 'Taiwan, China', value: 'TW' },
  { label: 'Tanzania', value: 'TZ' },
  { label: 'Ukraine', value: 'UA' },
  { label: 'Uganda', value: 'UG' },
  { label: 'United States Minor Outlying Islands', value: 'UM' },
  { label: 'United States', value: 'US' },
  { label: 'Uruguay', value: 'UY' },
  { label: 'Uzbekistan', value: 'UZ' },
  { label: 'Vatican City', value: 'VA' },
  { label: 'Saint Vincent and The Grenadines', value: 'VC' },
  { label: 'Venezuela', value: 'VE' },
  { label: 'British Virgin Islands', value: 'VG' },
  { label: 'Virgin Islands of the United States', value: 'VI' },
  { label: 'Vietnam', value: 'VN' },
  { label: 'Vanuatu', value: 'VU' },
  { label: 'Wallis and Futuna', value: 'WF' },
  { label: 'Samoa', value: 'WS' },
  { label: 'Yemen', value: 'YE' },
  { label: 'Mayotte', value: 'YT' },
  { label: 'South Africa', value: 'ZA' },
  { label: 'Zambia', value: 'ZM' },
  { label: 'Zimbabwe', value: 'ZW' },
];

export const GENRE_OPTIONS = [
  { label: 'All', value: 'ALL' },
  { label: 'Rock', value: 'ROCK' },
  { label: 'Pop', value: 'POP' },
  { label: 'Latin', value: 'LATIN' },
  { label: 'Metal', value: 'METAL' },
  { label: 'Electronic', value: 'ELECTRONIC' },
  { label: 'Hip Hop/Rap', value: 'HIP_HOP/RAP' },
  { label: 'Alternative/Indie', value: 'ALTERNATIVE/INDIE' },
  { label: 'Folk', value: 'FOLK' },
  { label: 'R&B/Soul', value: 'R&B/SOUL' },
  { label: 'Country', value: 'COUNTRY' },
  { label: 'Classical', value: 'CLASSICAL' },
  { label: 'Jazz', value: 'JAZZ' },
  { label: 'Reggae', value: 'REGGAE' },
  { label: 'Childhood', value: 'CHILDHOOD' },
  { label: 'Blues', value: 'BLUES' },
  { label: 'Easy Listening', value: 'EASY_LISTENING' },
  { label: 'New Age', value: 'NEW_AGE' },
  { label: 'World Music', value: 'WORLD_MUSIC' },
  { label: 'Experimental', value: 'EXPERIMENTAL' },
  { label: 'Devotional', value: 'DEVOTIONAL' },
  { label: 'Chinese Tradition', value: 'CHINESE_TRADITION' },
  { label: '8 Bit', value: '8_BIT' },
  { label: 'A capella', value: 'A_CAPPELLA' },
  { label: 'Afro-Pop', value: 'AFRO-POP' },
  { label: 'Alternative Hip Hop', value: 'ALTERNATIVE_HIP_HOP' },
  { label: 'Alternative Rock', value: 'ALTERNATIVE_ROCK' },
  { label: 'Ambient', value: 'AMBIENT' },
  { label: 'Arabic Pop', value: 'ARABIC_POP' },
  { label: 'Bass House', value: 'BASS_HOUSE' },
  { label: 'BGM', value: 'BGM' },
  { label: 'Boombap', value: 'BOOMBAP' },
  { label: 'Bossa Nova', value: 'BOSSA_NOVA' },
  { label: 'Brazilian Funk Style', value: 'BRAZILIAN_FUNK_STYLE' },
  { label: 'Buddhist Music', value: 'BUDDHIST_MUSIC' },
  { label: 'Cantopop', value: 'CANTOPOP' },
  { label: 'Celtic Pop', value: 'CELTIC_POP' },
  { label: 'Chamber Music', value: 'CHAMBER_MUSIC' },
  { label: 'Chill Beats', value: 'CHILL_BEATS' },
  { label: 'Chillout', value: 'CHILLOUT' },
  { label: 'Chinese Folk', value: 'CHINESE_FOLK' },
  { label: 'Chinese Opera', value: 'CHINESE_OPERA' },
  { label: 'Chinese Pop', value: 'CHINESE_POP' },
  { label: 'Chinese Style', value: 'CHINESE_STYLE' },
  { label: 'Chinoiserie Electronic', value: 'CHINOISERIE_ELECTRONIC' },
  { label: 'Chinoiserie Rap', value: 'CHINOISERIE_RAP' },
  { label: 'Christian Music', value: 'CHRISTIAN_MUSIC' },
  { label: 'Contemporary R&B', value: 'CONTEMPORARY_R&B' },
  { label: 'Country Pop', value: 'COUNTRY_POP' },
  { label: 'Dance Pop', value: 'DANCE_POP' },
  { label: 'Disco', value: 'DISCO' },
  { label: 'DJ', value: 'DJ' },
  { label: 'Drum&Bass', value: 'DRUM&BASS' },
  { label: 'Dubstep', value: 'DUBSTEP' },
  { label: 'EDM', value: 'EDM' },
  { label: 'EDM Trap', value: 'EDM_TRAP' },
  { label: 'Electro Pop', value: 'ELECTRO_POP' },
  { label: 'Epic', value: 'EPIC' },
  { label: 'Folk Pop', value: 'FOLK_POP' },
  { label: 'Funk', value: 'FUNK' },
  { label: 'Future Bass', value: 'FUTURE_BASS' },
  { label: 'Gospel', value: 'GOSPEL' },
  { label: 'Gufeng Music', value: 'GUFENG_MUSIC' },
  { label: 'Hard Rock', value: 'HARD_ROCK' },
  { label: 'Hip House', value: 'HIP_HOUSE' },
  { label: 'Holiday Music', value: 'HOLIDAY_MUSIC' },
  { label: 'House', value: 'HOUSE' },
  { label: 'Indian Pop', value: 'INDIAN_POP' },
  { label: 'Indie Folk', value: 'INDIE_FOLK' },
  { label: 'Indie Pop', value: 'INDIE_POP' },
  { label: 'Indie Rock', value: 'INDIE_ROCK' },
  { label: 'Instrumental Hip Hop', value: 'INSTRUMENTAL_HIP_HOP' },
  { label: 'Instrumental Rock', value: 'INSTRUMENTAL_ROCK' },
  { label: 'Irish Folk', value: 'IRISH_FOLK' },
  { label: 'J-Rock', value: 'J_ROCK' },
  { label: 'Japanese Traditional Music', value: 'JAPANESE_TRADITIONAL_MUSIC' },
  { label: 'Jazz Fusion', value: 'JAZZ_FUSION' },
  { label: 'Jazz Hip Hop', value: 'JAZZ_HIP_HOP' },
  { label: 'Jazz Pop', value: 'JAZZ_POP' },
  { label: 'J-Pop', value: 'J-POP' },
  { label: 'K-Pop', value: 'K-POP' },
  { label: 'Latin Pop', value: 'LATIN_POP' },
  { label: 'Lo-fi', value: 'LO-FI' },
  { label: 'MC', value: 'MC' },
  { label: 'Noise', value: 'NOISE' },
  { label: 'Old School', value: 'OLD_SCHOOL' },
  { label: 'Others', value: 'OTHERS' },
  { label: 'Pop Rap', value: 'POP_RAP' },
  { label: 'Pop Rock', value: 'POP_ROCK' },
  { label: 'Pop Soul', value: 'POP_SOUL' },
  { label: 'Psychedelic Rock', value: 'PSYCHEDELIC_ROCK' },
  { label: 'Punk', value: 'PUNK' },
  { label: 'R&B/Rap', value: 'R&B_RAP' },
  { label: 'Reggaeton', value: 'REGGAETON' },
  { label: 'Russian Pop', value: 'RUSSIAN_POP' },
  { label: 'Sertanejo', value: 'SERTANEJO' },
  { label: 'Son Cubano', value: 'SON_CUBANO' },
  { label: 'Soul', value: 'SOUL' },
  { label: 'Soundtrack', value: 'SOUNDTRACK' },
  { label: 'Symphony', value: 'SYMPHONY' },
  { label: 'Synth Pop', value: 'SYNTH_POP' },
  { label: 'Tango', value: 'TANGO' },
  { label: 'Techno', value: 'TECHNO' },
  { label: 'Teen Pop', value: 'TEEN_POP' },
  { label: 'Traditional Chinese Folk', value: 'TRADITIONAL_CHINESE_FOLK' },
  { label: 'Trance', value: 'TRANCE' },
  { label: 'Trap Rap', value: 'TRAP_RAP' },
  { label: 'Trip Hop', value: 'TRIP_HOP' },
  { label: 'Tropical House', value: 'TROPICAL_HOUSE' },
  { label: 'Turkish Pop', value: 'TURKISH_POP' },
];
